<template>
	<div>
		<GDataTableRemote
			class="mt-3"
			ref="mainTable"
			:remote-url="`/api/orders?owner=${user.id}`"
			:fields="fields"
			:items-per-page="10"
			hover
			striped
			sorter
			columnFilter
			pagination>
			<template #status="{ item }">
				<td>
					<CBadge :color="statusColor[item.status]">{{ statusTranslation[item.status] }}</CBadge>
				</td>
			</template>
			<template #actions="{ item }">
				<td>
					<router-link class="btn btn-link pt-0" :to="`/orders/${item.id}/edit`">
						<CIcon name="cil-magnifying-glass" />
					</router-link>
				</td>
			</template>
		</GDataTableRemote>
		<CartsProductsModal ref="cpDetails" />
		<PaymentsModal ref="pDetails" />
	</div>
</template>

<script>
	import GDataTableRemote from '../../../../components/ghostlexly-components/GDataTableRemote';
	import PaymentsModal from '../../../../components/modals/PaymentsModal';
	import CartsProductsModal from '../../../../components/modals/CartsProductsModal';

	export default {
		props: {
			user: Object,
		},
		components: { PaymentsModal, CartsProductsModal, GDataTableRemote },
		data() {
			this.statusOptions = [
				{ value: 'order.pending', label: 'En attente de paiement (CB)' },
				{ value: 'order.awaiting_delayed_payment', label: 'En attente de paiement différé' },
				{ value: 'order.paid', label: 'Payée' },
				{ value: 'order.paused', label: 'En pause' },
				{ value: 'order.admin_authorized', label: 'Autorisation direction' },
				{ value: 'order.complete', label: 'Terminée' },
				{ value: 'order.payment_issue', label: 'Erreur de paiement' },
				{ value: 'order.canceled', label: 'Annulée' },
				{ value: 'order.refund', label: 'Remboursée' },
			];
			return {
				fields: [
					{ key: 'id', label: 'Identifiant unique' },
					{ key: 'createdAt', label: 'Créée le', type: 'date' },
					{
						key: 'status',
						label: 'Statut',
						sorter: false,
						type: 'select',
						filterSelectOptions: this.statusOptions,
					},
					{ key: 'actions', filter: false },
				],
				statusTranslation: {
					'order.paused': 'En pause',
					'order.pending': 'En attente de paiement (CB)',
					'order.awaiting_delayed_payment': 'En attente de paiement différé',
					'order.paid': 'Payée',
					'order.admin_authorized': 'Autorisation direction',
					'order.complete': 'Terminée',
					'order.payment_issue': 'Erreur de paiement',
					'order.canceled': 'Annulée',
					'order.refund': 'Remboursée',
				},

				statusColor: {
					'order.paused': 'warning',
					'order.pending': 'warning',
					'order.awaiting_delayed_payment': 'warning',
					'order.paid': 'success',
					'order.admin_authorized': 'success',
					'order.complete': 'success',
					'order.payment_issue': 'danger',
					'order.canceled': 'danger',
					'order.refund': 'warning',
				},
			};
		},
		methods: {
			openDetails(queryUrl, ref) {
				this.$refs[ref].queryUrl = queryUrl;
				this.$refs[ref].showModal = true;
			},
		},
	};
</script>
